import { Card, Grid } from '@mui/material';
import LoadingSpinner from '../components/Spinner/loading.spinner';
import React from 'react';
import checked from './validators';

const buildGridItem = (metrics, contents, title, sizeScaling) => {
  if (!sizeScaling){
    return `Size scaling was not defined for ${title}`;
  }

  return (
    <Grid
      item
      xl={sizeScaling.xl}
      lg={sizeScaling.lg}
      md={sizeScaling.md}
      sm={sizeScaling.sm}
      xs={sizeScaling.xs}
      key={title}
    >
      {metrics ?
        contents : (<Card><LoadingSpinner title={`Loading ${title}`}/></Card>)
      }
    </Grid>
  )
}

export default buildGridItem;
